import React from "react"
import { Modal, Button } from "antd"
import { termsOfServiceContent } from "../../../utils/termsOfServiceContent"
import "./privacypolicy.css"

const TermsOfServiceModal = ({ isOpen, onClose, translations, currentLang }) => {
  const btn = translations[currentLang]?.common_btn
  const termsData = termsOfServiceContent[currentLang]

  if (!termsData) {
    return null
  }

  const renderBlock = (block, index) => {
    if (block.type === "subtitle") {
      return (
        <h5 key={index} className="privacy-section-subtitle mb-2">
          {block.text}
        </h5>
      )
    }

    if (block.type === "list") {
      return (
        <ul key={index} className="privacy-list">
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )
    }

    return (
      <p key={index} className="mb-3">
        {block.text}
      </p>
    )
  }

  return (
    <Modal
      title={termsData.title}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {btn?.close}
        </Button>,
      ]}
      width={800}
      className={`privacy-policy-modal ${currentLang === "ar" ? "rtl-text" : ""}`}
    >
      <div className="privacy-policy-container">
        {termsData.intro?.map((paragraph, i) => (
          <p key={i} className="privacy-intro mb-3">
            {paragraph}
          </p>
        ))}

        {termsData.sections?.map((section, i) => (
          <div key={i} className="privacy-section mb-4">
            <h4 className="privacy-section-title mb-3">{section.title}</h4>
            {section.blocks.map(renderBlock)}
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default TermsOfServiceModal
